const Layout = {
  isHeaderSticky: false,
  addToCart: async function(quantity, productId) {
    const addToCartResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        quantity: quantity,
        id: productId,
        sections: 'cart-items,cart-sidebar'
      })
    });
    const addToCartResponseJson = await addToCartResponse.json();

    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    const responseJson = await response.json();
    const headerCartItemCountElement = document.querySelector('.header__cart-button-count');
    headerCartItemCountElement.innerText = responseJson.item_count;
    if (responseJson.item_count > 0) {
      headerCartItemCountElement.classList.remove('header__cart-button-count--hidden');
      document.getElementById('cart').classList.remove('cart-page--empty');

      const cartItems = document.createElement('div');
      cartItems.innerHTML = addToCartResponseJson.sections['cart-items'];
      document.getElementById('shopify-section-cart-items').innerHTML = cartItems.querySelector('#shopify-section-cart-items').innerHTML;

      const cartSidebar = document.createElement('div');
      cartSidebar.innerHTML = addToCartResponseJson.sections['cart-sidebar'];
      document.getElementById('shopify-section-cart-sidebar').innerHTML = cartSidebar.querySelector('#shopify-section-cart-sidebar').innerHTML;

      initCartPage();

      Layout.showCartSidebar();

    } else {
      headerCartItemCountElement.classList.add('header__cart-button-count--hidden');
      document.getElementById('cart').classList.add('cart-page--empty');
    }
  },
  hideCartSidebar: function() {
    const cartSidebarOverlay = document.querySelector('.cart-sidebar__overlay');
    if (cartSidebarOverlay !== null) {
      cartSidebarOverlay.style.pointerEvents = 'none';
      document.body.classList.remove('body--cart-sidebar-open');
      setTimeout(() => {
        cartSidebarOverlay.right = 'auto';
        cartSidebarOverlay.bottom = 'auto';
        cartSidebarOverlay.style.pointerEvents = 'auto';
      }, 300);
    }
  },
  showCartSidebar: function() {
    const cartSidebarOverlay = document.querySelector('.cart-sidebar__overlay');
    if (cartSidebarOverlay !== null) {
      cartSidebarOverlay.right = 0;
      cartSidebarOverlay.bottom = 0;
      document.body.classList.add('body--cart-sidebar-open');
    }
  },
  formatPrice: function (price) {
    const priceArray = (price + '').split('');
    let formattedPriceArray = [
      ...priceArray.slice(0, priceArray.length - 2),
      ',',
      ...priceArray.slice(priceArray.length - 2)
    ];
    if (price >= 100000) {
      formattedPriceArray = [
        ...formattedPriceArray.slice(0, formattedPriceArray.length - 6),
        '.',
        ...formattedPriceArray.slice(formattedPriceArray.length - 6)
      ];
    }
    return formattedPriceArray.join('');
  }
};


function updateLayoutHeaderSticky() {
  if (window.scrollY >= 32) {
    if (!Layout.isHeaderSticky) {
      Layout.isHeaderSticky = true;
      document.body.classList.add('body--sticky-header');
    }
  } else if (Layout.isHeaderSticky) {
    Layout.isHeaderSticky = false;
    document.body.classList.remove('body--sticky-header');
  }
}


function initLayoutHeader() {
  window.addEventListener('scroll', updateLayoutHeaderSticky);
  updateLayoutHeaderSticky();
}


function initLayoutMobileMenu() {
  const mobileMenuButton = document.getElementById('mobile-menu-button');
  mobileMenuButton.addEventListener('click', () => {
    if (document.body.classList.contains('body--mobile-menu-open')) {
      document.body.classList.remove('body--mobile-menu-open');
      const mobileMenuInlays = document.querySelectorAll('.mobile-menu__inlay');
      mobileMenuInlays.forEach((mobileMenuInlay) => {
        mobileMenuInlay.classList.remove('mobile-menu__inlay--left');
        if (mobileMenuInlay.dataset.url !== 'root') {
          mobileMenuInlay.classList.add('mobile-menu__inlay--right');
        }
      });
    } else {
      document.body.classList.add('body--mobile-menu-open');
    }
  });

  const mobileMenuZoomInButtons = document.querySelectorAll('.mobile-menu__link-zoom-in-button');
  mobileMenuZoomInButtons.forEach((mobileMenuZoomInButton) => {
    mobileMenuZoomInButton.addEventListener('click', () => {
      const currentMobileMenuInlay = mobileMenuZoomInButton.closest('.mobile-menu__inlay');
      const nextMobileMenuInlay = document.querySelector('.mobile-menu__inlay[data-url="' + mobileMenuZoomInButton.dataset.url + '"]');
      currentMobileMenuInlay.classList.add('mobile-menu__inlay--left');
      nextMobileMenuInlay.classList.remove('mobile-menu__inlay--right');
    });
  });

  const mobileMenuZoomOutButtons = document.querySelectorAll('.mobile-menu__link-zoom-out-button');
  mobileMenuZoomOutButtons.forEach((mobileMenuZoomOutButton) => {
    mobileMenuZoomOutButton.addEventListener('click', () => {
      const previousMobileMenuInlay = document.querySelector('.mobile-menu__inlay[data-url="' + mobileMenuZoomOutButton.dataset.url + '"]');
      const currentMobileMenuInlay = mobileMenuZoomOutButton.closest('.mobile-menu__inlay');
      previousMobileMenuInlay.classList.remove('mobile-menu__inlay--left');
      currentMobileMenuInlay.classList.add('mobile-menu__inlay--right');
    });
  });
}


function initLayoutNewsletterForm() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('customer_posted') === 'true') {
    let top = document.getElementById('footer').getBoundingClientRect().top + window.scrollY - 80;
    if (window.innerWidth < 1024) {
      top = document.getElementById('footer-newsletter-form').getBoundingClientRect().top + window.scrollY - 144;
    }
    setTimeout(function() {
      window.scrollTo({
        top: top,
        left: 0,
        behavior: 'instant',
      });
    }, 0);
  }
}


function initLayoutBottomRibbon() {
  const bottomRibbon = document.querySelector('.bottom-ribbon');
  if (bottomRibbon === null) {
    return;
  }
  const isBottomRibbonHidden = localStorage.getItem('bottomRibbon.' + bottomRibbon.dataset.cacheId) === 'true';
  if (!isBottomRibbonHidden) {
    bottomRibbon.classList.add('bottom-ribbon--visible');
    const bottomRibbonCloseButton = bottomRibbon.querySelector('.bottom-ribbon__close-button');
    bottomRibbonCloseButton.addEventListener('click', () => {
      bottomRibbon.classList.remove('bottom-ribbon--visible');
      localStorage.setItem('bottomRibbon.' + bottomRibbon.dataset.cacheId, 'true');
    });
  }
}

function initLayoutCartSidebar() {
  const cartSidebarOverlay = document.querySelector('.cart-sidebar__overlay');
  if (cartSidebarOverlay === null) {
    return;
  }
  if (cartSidebarOverlay.classList.contains('cart-sidebar__overlay--initialized')) {
    return;
  }
  cartSidebarOverlay.classList.add('cart-sidebar__overlay--initialized');

  cartSidebarOverlay.addEventListener('click', () => {
    Layout.hideCartSidebar();
  });

  const cartSidebarItems = document.querySelector('.cart-page__items');
  const cartSidebarSidebar = document.querySelector('.cart-sidebar .cart-page__sidebar');
  cartSidebarItems.style.marginBottom = cartSidebarSidebar.offsetHeight + 'px';
}


function initLayout() {
  initLayoutHeader();
  initLayoutMobileMenu();
  initLayoutNewsletterForm();
  initLayoutBottomRibbon();
  initLayoutCartSidebar();
}


window.addEventListener('load', (event) => {
  initLayoutBottomRibbon();
  initLayoutNewsletterForm();
  initLayoutCartSidebar();
});


if (document.readyState !== 'loading') {
  initLayout();
} else {
  window.addEventListener('DOMContentLoaded', initLayout);
}
